<template>
  <div class="faq">
    <nav-bar></nav-bar>
    <div class="container second-container">
        <div class="hero-body">
            <div class="columns is-vcentered custom-vertical-space">
                <div class="column is-12"></div>
            </div>
            <div class="columns">
                <div class="column is-10-fullhd is-offset-1-fullhd products-title">
                <div class="content">
                    <h1 class="is-uppercase has-text-centered has-text-primary">
                    {{texts.title}}
                    </h1>
                </div>
                </div>
            </div>
            <div class="qasContainer">
                <div v-for="(faq, index) in faqs" :key="faq.q" class="qAndAs">
                    <div class="question has-text-primary" v-html="textQA[faq.q]"></div>
                    <div class="answer has-text-primary" v-html=" textQA[faq.a]"></div>
                    <div v-if="index != faqs.length-1" class="greyLine"></div>       
                </div>      
            </div>     
        </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import NavBar from "./Navbar.vue";
import AppFooter from "./AppFooter.vue";

export default {
  name: "Faq",
  data() {
    return {
        faqs: [
            {
                q: "q1",
                a: "a1"
            },
            {
                q: "q2",
                a: "a2"
            },
            {
                q: "q3",
                a: "a3"
            },
            {
                q: "q4",
                a: "a4"
            },
            {
                q: "q5",
                a: "a5"
            },
            {
                q: "q6",
                a: "a6"
            },
            {
                q: "q7",
                a: "a7"
            },
            {
                q: "q8",
                a: "a8"
            },
            {
                q: "q9",
                a: "a9"
            },
            {
                q: "q10",
                a: "a10"
            },
           
        ]
    };
  },
  components: {
    NavBar: NavBar,
    AppFooter: AppFooter,
  },
  computed:{
      texts(){
          return this.$t('faq')
      },
       textQA(){
          return this.$t('faq.qas')
      },    
  },
};
</script>

<style lang="scss">
.qasContainer {
    padding: 3rem 0 6rem 0;
    .qAndAs {
        padding: 1.3rem 0;
    }

    .question {
        font-weight: bold;
        margin-bottom: 1rem;
    }
    .answe {
        font-weight: normal;
    }
    .greyLine {
        width: 100%;
        border-bottom: 1px solid #E0E0E0;
        margin-top: 2rem;
    }
    .columns .products-title p, li {
        font-style: normal;
    }

}
</style>
